import { MdSportsSoccer } from 'react-icons/md';
import { handleText } from '../../../utils/handle-text';
import resolverRewardFut from '../../../utils/resolver-reward-fut';
import resolverTexts from '../../../utils/resolver-texts';
import { dataMovimento } from '../modules/dataMovimento';

export const CardProduct = ({ onClick, ...product }) => {
  return (
    <div className="position-relative pointer my-2 ">
      <div onClick={onClick} className="card card-body    ">
        <div className="d-flex d-flex  gap-2 align-items-center justify-content-start">
          <div className=" d-flex d-flex  gap-2 align-items-center justify-content-start ">
          <strong>{product?.cod}</strong>

            {resolverTexts(product.status)}
            {resolverRewardFut(
              product.status,
              product.status_premio_futebol,
              product.valor_premios
            )}
          </div>
        </div>
        <div className="row mt-2">

        {/* <div className="col-6 col-md-4 d-flex flex-column text-center ">
            <small>Código</small>
          </div> */}
             <div className="col-6 col-md-4  d-flex flex-column text-center ">
            <small>Jogos</small>
            <strong>{product?.jogos_futebol?.length}</strong>
          </div>
          <div className="col-6 col-md-4 d-flex flex-column text-center ">
            <small>Forma de pagamento</small>
            <strong>{product.forma_pagamento}</strong>
          </div>

          <div className="col-6 col-md-4 d-flex flex-column text-center ">
            <small>Cotação</small>
            <strong> {product.cotacao_bilhete.toFixed(2)}</strong>
          </div>

          <div className="col-6 col-md-4 d-flex flex-column text-center ">
            <small>Valor total</small>
            <strong>{handleText.asMoney(product.valor_bruto)}</strong>
          </div>

          <div className="col-6 col-md-4 d-flex flex-column text-center ">
            <small>Data</small>
            <strong>{dataMovimento(product.data_movimento, product.futebol)}</strong>
          </div>

          <div className="col-6 col-md-4  d-flex flex-column text-center ">
            <small>Possível retorno</small>
            <strong>{handleText.asMoney(product.possivel_premio)}</strong>
          </div>

       
        </div>
      </div>

      <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-primary">
        <MdSportsSoccer size={15} />
      </span>
    </div>
  );
};
